import {BOT_CONV_MESSAGE_TYPE} from '../../../../helpers/consts/common-consts';
import './index.css';
import dayjs from 'dayjs';
import TextMessage from "../text-message/text-message";
export default function Index({ message, senderType }) {
  return (
      <div className='w-full my-2'>
          <div className='message-text'>
              <img className='w-60 h-60 border rounded-lg' src={message.url} />
              <TextMessage message={message.caption} senderType={senderType} />
          </div>
      </div>
  );
}
